<template>
  <div>
    <button v-if="show" class="share-button" @click="toggleQr">
      <i class="mdi mdi-share-variant share-icon">+</i>
    </button>
    <b-modal
      :active.sync="showQr"
      custom-class="qr-modal"
      width="auto"
      :can-cancel="['escape','outside']"
    >
      <div class="qr-content">
        <!-- 1) QR -->
        <vue-qr ref="qr" :text="currentUrl" :size="220" />
        <!-- 2) Botón centrado y separado -->
        <button class="download-btn" @click="downloadQr">
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
export default {
  name: 'ShareButton',
  components: { VueQr },
  data() {
    return { showQr: false }
  },
  computed: {
    show() {
      return ['InfoProducto','InfoRestaurante'].includes(this.$route.name)
    },
    currentUrl() {
      return window.location.href
    }
  },
  methods: {
    toggleQr() {
      this.showQr = !this.showQr
    },
    downloadQr() {
      const canvas = this.$refs.qr.$el.querySelector('canvas')
      if (!canvas) return
      const link = document.createElement('a')
      link.href = canvas.toDataURL('image/png')
      link.download = 'codigo-qr.png'
      link.click()
    }
  }
}
</script>

<style scoped>
/* Mantiene tu overlay tal cual */
::v-deep .qr-modal .modal-background {
  background-color: rgba(255, 255, 255, 0.5) !important;
}
/* Mantiene tu “cartón” tal cual */
::v-deep .qr-modal .modal-card,
::v-deep .qr-modal .modal-content {
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.1);
}

/* 1) Flex column para QR + botón */
.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}

/* 2) Botón con separación */
.download-btn {
  margin-top: 1rem;
  padding: 0.4rem 1rem;
  background-color: #2C73D2; /* o el color que prefieras */
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}
.download-btn:hover {
  background-color: #235bb0;
}

/* Tu botón de compartir sin cambios */
.share-button {
  position: fixed;
  top: 56px;
  right: 14px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  padding: 8px;
  border-radius: 24px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  cursor: pointer;
  z-index: 1000;
  transition: background 0.2s, transform 0.1s;
}
.share-button:hover {
  background: rgba(0,0,0,0.8);
  transform: translateY(-1px);
}
.share-icon { font-size: 20px; }
</style>
